import { NgModule } from '@angular/core';
import { Ga4GgListingPageEventBuilder } from './ga4-gg-listing-page-event.builder';

@NgModule({})
export class Ga4GgListingPageEventModule {
  constructor(_ga4GgCategoryPageEventBuilder: Ga4GgListingPageEventBuilder) {}
}
